"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryActivity = void 0;
const HistoryActivityList_1 = require("./HistoryActivityList");
class HistoryActivity {
    get activityTitle() {
        var _a;
        const activityName = this.activity_channel_name === 'poll' ||
            this.activity_channel_name === 'quiz' ||
            this.activity_channel_name === 'survey'
            ? this.public_title
            : this.title;
        return ((_a = this.base_extra_data) === null || _a === void 0 ? void 0 : _a.display_name) ? this.base_extra_data.display_name : activityName;
    }
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.title = data.title;
        this.description = data.description;
        this.image = data.image;
        this.activity_id = data.activity_id;
        this.num_points = data.num_points;
        this.base_num_points = data.base_num_points;
        this.category_id = data.category_id;
        this.category_name = data.category_name;
        this.type_id = data.type_id;
        this.type_name = data.type_name;
        this.history_type = data.history_type;
        this.activity_channel_id = data.activity_channel_id;
        this.activity_channel_name = data.activity_channel_name;
        this.freq_cap = data.freq_cap;
        this.freq_period_id = data.freq_period_id;
        this.freq_period_name = data.freq_period_name;
        this.freq_num_required_attempts = data.freq_num_required_attempts;
        this.redirect_url = data.redirect_url;
        this.points_on_click = data.points_on_click;
        this.action_tags = data.action_tags;
        this.date_awarded = data.date_awarded;
        this.date_created = data.date_created;
        this.extra_data = data.extra_data;
        this.base_extra_data = data.base_extra_data;
        this.public_title = data.public_title;
        this.public_description = data.public_description;
        this.date_start = data.date_start;
        this.date_end = data.date_end;
        this.min_tier_id = data.min_tier_id;
        this.is_hidden_by_tier = data.is_hidden_by_tier;
        this.is_locked_by_tier = data.is_locked_by_tier;
        this.show_as_locked_by_tier = data.show_as_locked_by_tier;
        this.dateAwarded = null;
        this.bonusPoints = null;
    }
}
exports.HistoryActivity = HistoryActivity;
HistoryActivity.JsonToActivities = (data) => {
    const activityList = new HistoryActivityList_1.HistoryActivityList();
    data.forEach(activity => {
        if (activity.extra_data && activity.extra_data['pre_assigned']) {
            activity.extra_data['pre_assigned'] = activity.extra_data['pre_assigned'] === 'true';
        }
        activityList.push(HistoryActivity.JsonToActivity(activity));
    });
    return activityList.getDateStartSorted();
};
HistoryActivity.LegerJsonToActivities = (data) => {
    const activityList = new HistoryActivityList_1.HistoryActivityList();
    data.forEach(activity => {
        var _a, _b;
        const extraData = {};
        (activity === null || activity === void 0 ? void 0 : activity.extraData) &&
            Object.keys(activity === null || activity === void 0 ? void 0 : activity.extraData).forEach(item => {
                if (!(activity === null || activity === void 0 ? void 0 : activity.extraData))
                    return;
                extraData[activity === null || activity === void 0 ? void 0 : activity.extraData[item].key] = activity === null || activity === void 0 ? void 0 : activity.extraData[item].value;
            }, {});
        const dateAsNumber = new Date(activity.date).getTime() / 1000;
        const bonusPoints = extraData.bonus;
        const basePoints = activity.amount - (bonusPoints ? bonusPoints.value : 0);
        const newActivity = new HistoryActivity({
            id: null,
            name: '',
            title: activity.description,
            description: '',
            image: '',
            activity_id: '',
            num_points: activity.amount,
            base_num_points: basePoints.toString(),
            category_id: 1,
            category_name: '',
            type_id: 1,
            type_name: (_a = activity.type) !== null && _a !== void 0 ? _a : '',
            history_type: (_b = activity.historyType) !== null && _b !== void 0 ? _b : '',
            activity_channel_id: null,
            activity_channel_name: null,
            freq_cap: null,
            freq_period_id: null,
            freq_period_name: null,
            freq_num_required_attempts: null,
            redirect_url: null,
            points_on_click: false,
            action_tags: null,
            date_awarded: dateAsNumber,
            date_created: null,
            extra_data: extraData,
            base_extra_data: null,
            public_title: activity.description,
            public_description: '',
            date_start: null,
            date_end: null,
            min_tier_id: null,
            is_hidden_by_tier: null,
            is_locked_by_tier: null,
            show_as_locked_by_tier: null
        });
        if (newActivity.extra_data && (newActivity === null || newActivity === void 0 ? void 0 : newActivity.extra_data['pre_assigned'])) {
            newActivity.extra_data['pre_assigned'] = newActivity.extra_data['pre_assigned'] === 'true';
        }
        activityList.push(HistoryActivity.JsonToActivity(newActivity));
    });
    return activityList.getDateStartSorted();
};
HistoryActivity.JsonToActivity = (data) => new HistoryActivity(data);
//# sourceMappingURL=HistoryActivity.js.map